import PropTypes from 'prop-types'
import CustomDrawer from "@UI/CustomDrawer"
import { Button } from "antd"
import { useLogs } from '@tcomponents/Logs/hooks/useLogs'
import './styles.css'
import { CloseCircleOutlined } from '@ant-design/icons'

const LogsDrawer = ({ isOpen, onClose, redirectTo, service, logsParams }) => {
    const { logsData, handleRedirectTo } = useLogs({
        format: 'list',
        url: service,
        otherParams: logsParams
    })

    return (
        <CustomDrawer
            title="Historial de cambios"
            placement="right"
            closable={true}
            closeIcon={<CloseCircleOutlined />}
            destroyOnClose={true}
            onClose={onClose}
            isOpenDrawer={isOpen}
            width={425}
        >
            <div className='logs-drawer-body'>
                {
                    logsData?.map?.((log, index) => (
                        <div className='logs-drawer-item' key={index}>
                            <div className='logs-drawer-item-header'>
                                <div className='logs-drawer-item-header-profile'>
                                    <img
                                        className='logs-drawer-item-header-profile-image'
                                        width={32}
                                        height={32}
                                        src={log.profile.image}
                                        alt={log.profile.full_name}
                                    />
                                    <span>
                                        {log.profile.full_name}
                                    </span>
                                </div>
                                <strong>{log.date}</strong>
                            </div>
                            <div className='logs-drawer-item-body'>
                                {
                                    log.changes.map((item, index) => {
                                        return (
                                            <p key={index}>{item}</p>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    ))
                }
                <div className='logs-drawer-all-container'>
                    <Button
                        className='logs-drawer-all-button'
                        style={{
                            width: '100px'
                        }}
                        onClick={() => handleRedirectTo(redirectTo,
                            {
                                state: {
                                    redirectTo,
                                    url: service,
                                    logsParams
                                }
                            })}
                    >
                        VER TODOS
                    </Button>
                </div>
            </div>
        </CustomDrawer>
    )
}

LogsDrawer.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    redirectTo: PropTypes.string.isRequired,
    service: PropTypes.func.isRequired,
    logsParams: PropTypes.object
}

export default LogsDrawer
